import React from "react";
import { Box, TextField, MenuItem } from "@mui/material";

const FilterBar = ({
  category,
  language,
  status,
  onCategoryChange,
  onLanguageChange,
  onStatusChange,
}) => (
  <Box
    sx={{
      display: "flex",
      gap: { xs: 0.5, sm: 0.75, md: 1, lg: 1, xl: 1 },
      flexWrap: { xs: "nowrap", sm: "nowrap", md: "nowrap", lg: "nowrap", xl: "nowrap" },
      width: { xs: "68%", sm: "68%", md: "auto", lg: "auto", xl: "auto" },
      flexShrink: { xs: 0, sm: 0, md: 0, lg: 0, xl: 0 },
    }}
  >
    <TextField
      select
      label="Category"
      value={category}
      onChange={(e) => onCategoryChange(e.target.value)}
      variant="outlined"
      size="small"
      sx={{
        minWidth: {
          xs: "calc(33.33% - 4px)",
          sm: "calc(33.33% - 6px)",
          md: 120,
          lg: 140,
          xl: 140,
        },
        width: {
          xs: "calc(33.33% - 4px)",
          sm: "calc(33.33% - 6px)",
          md: "auto",
          lg: "auto",
          xl: "auto",
        },
        background: (theme) => theme.palette.background.paper,
        "& .MuiOutlinedInput-root": {
          "& fieldset": {
            borderColor: (theme) => theme.palette.divider,
          },
          "&:hover fieldset": {
            borderColor: (theme) => theme.palette.primary.main,
          },
        },
        "& .MuiInputLabel-root": {
          color: (theme) => theme.palette.text.secondary,
          fontSize: { xs: "11px", sm: "12px", md: "13px", lg: "14px", xl: "14px" },
        },
        "& .MuiSelect-select": {
          color: (theme) => theme.palette.text.primary,
          fontSize: { xs: "11px", sm: "12px", md: "13px", lg: "14px", xl: "14px" },
          padding: { xs: "6px 28px 6px 10px", sm: "7px 30px 7px 12px", md: "8px 32px 8px 12px", lg: "10px 32px 10px 14px", xl: "10px 32px 10px 14px" },
        },
        "& .MuiSelect-icon": {
          fontSize: { xs: "16px", sm: "18px", md: "20px", lg: "24px", xl: "24px" },
        },
      }}
      SelectProps={{
        MenuProps: {
          anchorOrigin: { vertical: "bottom", horizontal: "left" },
          transformOrigin: { vertical: "top", horizontal: "left" },
          PaperProps: {
            sx: { mt: 0.5 }, // push menu slightly below the select so it doesn't cover the field
          },
        },
      }}
    >
      <MenuItem value="All">All</MenuItem>
      <MenuItem value="UTILITY">Utility</MenuItem>
      <MenuItem value="MARKETING">Marketing</MenuItem>
      <MenuItem value="AUTHENTICATION">Authentication</MenuItem>
    </TextField>
    <TextField
      select
      label="Language"
      value={language}
      onChange={(e) => onLanguageChange(e.target.value)}
      variant="outlined"
      size="small"
      sx={{
        minWidth: {
          xs: "calc(33.33% - 4px)",
          sm: "calc(33.33% - 6px)",
          md: 120,
          lg: 140,
          xl: 140,
        },
        width: {
          xs: "calc(33.33% - 4px)",
          sm: "calc(33.33% - 6px)",
          md: "auto",
          lg: "auto",
          xl: "auto",
        },
        background: (theme) => theme.palette.background.paper,
        "& .MuiOutlinedInput-root": {
          "& fieldset": {
            borderColor: (theme) => theme.palette.divider,
          },
          "&:hover fieldset": {
            borderColor: (theme) => theme.palette.primary.main,
          },
        },
        "& .MuiInputLabel-root": {
          color: (theme) => theme.palette.text.secondary,
          fontSize: { xs: "11px", sm: "12px", md: "13px", lg: "14px", xl: "14px" },
        },
        "& .MuiSelect-select": {
          color: (theme) => theme.palette.text.primary,
          fontSize: { xs: "11px", sm: "12px", md: "13px", lg: "14px", xl: "14px" },
          padding: { xs: "6px 28px 6px 10px", sm: "7px 30px 7px 12px", md: "8px 32px 8px 12px", lg: "10px 32px 10px 14px", xl: "10px 32px 10px 14px" },
        },
        "& .MuiSelect-icon": {
          fontSize: { xs: "16px", sm: "18px", md: "20px", lg: "24px", xl: "24px" },
        },
      }}
      SelectProps={{
        MenuProps: {
          anchorOrigin: { vertical: "bottom", horizontal: "left" },
          transformOrigin: { vertical: "top", horizontal: "left" },
          PaperProps: {
            sx: { mt: 0.5 }, // push menu slightly below the select so it doesn't cover the field
          },
        },
      }}
    >
      <MenuItem value="All">All</MenuItem>
      <MenuItem value="en">English</MenuItem>
      <MenuItem value="es">Spanish</MenuItem>
      <MenuItem value="af">Afrikaans</MenuItem>
      <MenuItem value="sq">Albanian</MenuItem>
      <MenuItem value="ar">Arabic</MenuItem>
      <MenuItem value="ar_EG">Arabic (EGY)</MenuItem>
      <MenuItem value="ar_AE">Arabic (UAE)</MenuItem>
      <MenuItem value="ar_LB">Arabic (LBN)</MenuItem>
      <MenuItem value="ar_MA">Arabic (MAR)</MenuItem>
      <MenuItem value="ar_QA">Arabic (QAT)</MenuItem>
      <MenuItem value="az">Azerbaijani</MenuItem>
      <MenuItem value="be_BY">Belarusian</MenuItem>
      <MenuItem value="bn">Bengali</MenuItem>
      <MenuItem value="bn_IN">Bengali (IND)</MenuItem>
      <MenuItem value="bg">Bulgarian</MenuItem>
      <MenuItem value="ca">Catalan</MenuItem>
      <MenuItem value="zh_CN">Chinese (CHN)</MenuItem>
      <MenuItem value="zh_HK">Chinese (HKG)</MenuItem>
      <MenuItem value="zh_TW">Chinese (TAI)</MenuItem>
      <MenuItem value="hr">Croatian</MenuItem>
      <MenuItem value="cs">Czech</MenuItem>
      <MenuItem value="da">Danish</MenuItem>
      <MenuItem value="prs_AF">Dari</MenuItem>
      <MenuItem value="nl">Dutch</MenuItem>
      <MenuItem value="nl_BE">Dutch (BEL)</MenuItem>
      <MenuItem value="en_GB">English (UK)</MenuItem>
      <MenuItem value="en_US">English (US)</MenuItem>
      <MenuItem value="en_AE">English (UAE)</MenuItem>
      <MenuItem value="en_AU">English (AUS)</MenuItem>
      <MenuItem value="en_CA">English (CAN)</MenuItem>
      <MenuItem value="en_GH">English (GHA)</MenuItem>
      <MenuItem value="en_IE">English (IRL)</MenuItem>
      <MenuItem value="en_IN">English (IND)</MenuItem>
      <MenuItem value="en_JM">English (JAM)</MenuItem>
      <MenuItem value="en_MY">English (MYS)</MenuItem>
      <MenuItem value="en_NZ">English (NZL)</MenuItem>
      <MenuItem value="en_QA">English (QAT)</MenuItem>
      <MenuItem value="en_SG">English (SGP)</MenuItem>
      <MenuItem value="en_UG">English (UGA)</MenuItem>
      <MenuItem value="en_ZA">English (ZAF)</MenuItem>
      <MenuItem value="et">Estonian</MenuItem>
      <MenuItem value="fil">Filipino</MenuItem>
      <MenuItem value="fi">Finnish</MenuItem>
      <MenuItem value="fr">French</MenuItem>
      <MenuItem value="fr_BE">French (BEL)</MenuItem>
      <MenuItem value="fr_CA">French (CAN)</MenuItem>
      <MenuItem value="fr_CH">French (CHE)</MenuItem>
      <MenuItem value="fr_CI">French (CIV)</MenuItem>
      <MenuItem value="fr_MA">French (MAR)</MenuItem>
      <MenuItem value="ka">Georgian</MenuItem>
      <MenuItem value="de">German</MenuItem>
      <MenuItem value="de_AT">German (AUT)</MenuItem>
      <MenuItem value="de_CH">German (CHE)</MenuItem>
      <MenuItem value="el">Greek</MenuItem>
      <MenuItem value="gu">Gujarati</MenuItem>
      <MenuItem value="ha">Hausa</MenuItem>
      <MenuItem value="he">Hebrew</MenuItem>
      <MenuItem value="hi">Hindi</MenuItem>
      <MenuItem value="hu">Hungarian</MenuItem>
      <MenuItem value="id">Indonesian</MenuItem>
      <MenuItem value="ga">Irish</MenuItem>
      <MenuItem value="it">Italian</MenuItem>
      <MenuItem value="ja">Japanese</MenuItem>
      <MenuItem value="kn">Kannada</MenuItem>
      <MenuItem value="kk">Kazakh</MenuItem>
      <MenuItem value="rw_RW">Kinyarwanda</MenuItem>
      <MenuItem value="ko">Korean</MenuItem>
      <MenuItem value="ky_KG">Kyrgyz (Kyrgyzstan)</MenuItem>
      <MenuItem value="lo">Lao</MenuItem>
      <MenuItem value="lv">Latvian</MenuItem>
      <MenuItem value="lt">Lithuanian</MenuItem>
      <MenuItem value="mk">Macedonian</MenuItem>
      <MenuItem value="ms">Malay</MenuItem>
      <MenuItem value="ml">Malayalam</MenuItem>
      <MenuItem value="mr">Marathi</MenuItem>
      <MenuItem value="nb">Norwegian</MenuItem>
      <MenuItem value="ps_AF">Pashto</MenuItem>
      <MenuItem value="fa">Persian</MenuItem>
      <MenuItem value="pl">Polish</MenuItem>
      <MenuItem value="pt_BR">Portuguese (BR)</MenuItem>
      <MenuItem value="pt_PT">Portuguese (POR)</MenuItem>
      <MenuItem value="pa">Punjabi</MenuItem>
      <MenuItem value="ro">Romanian</MenuItem>
      <MenuItem value="ru">Russian</MenuItem>
      <MenuItem value="sr">Serbian</MenuItem>
      <MenuItem value="si_LK">Sinhala</MenuItem>
      <MenuItem value="sk">Slovak</MenuItem>
      <MenuItem value="sl">Slovenian</MenuItem>
      <MenuItem value="es_AR">Spanish (ARG)</MenuItem>
      <MenuItem value="es_CL">Spanish (CHL)</MenuItem>
      <MenuItem value="es_CO">Spanish (COL)</MenuItem>
      <MenuItem value="es_CR">Spanish (CRI)</MenuItem>
      <MenuItem value="es_DO">Spanish (DOM)</MenuItem>
      <MenuItem value="es_EC">Spanish (ECU)</MenuItem>
      <MenuItem value="es_HN">Spanish (HND)</MenuItem>
      <MenuItem value="es_MX">Spanish (MEX)</MenuItem>
      <MenuItem value="es_PA">Spanish (PAN)</MenuItem>
      <MenuItem value="es_PE">Spanish (PER)</MenuItem>
      <MenuItem value="es_ES">Spanish (SPA)</MenuItem>
      <MenuItem value="es_UY">Spanish (URY)</MenuItem>
      <MenuItem value="sw">Swahili</MenuItem>
      <MenuItem value="sv">Swedish</MenuItem>
      <MenuItem value="ta">Tamil</MenuItem>
      <MenuItem value="te">Telugu</MenuItem>
      <MenuItem value="th">Thai</MenuItem>
      <MenuItem value="tr">Turkish</MenuItem>
      <MenuItem value="uk">Ukrainian</MenuItem>
      <MenuItem value="ur">Urdu</MenuItem>
      <MenuItem value="uz">Uzbek</MenuItem>
      <MenuItem value="vi">Vietnamese</MenuItem>
      <MenuItem value="zu">Zulu</MenuItem>
    </TextField>
    <TextField
      select
      label="Status"
      value={status}
      onChange={(e) => onStatusChange(e.target.value)}
      variant="outlined"
      size="small"
      sx={{
        minWidth: {
          xs: "calc(33.33% - 4px)",
          sm: "calc(33.33% - 6px)",
          md: 120,
          lg: 140,
          xl: 140,
        },
        width: {
          xs: "calc(33.33% - 4px)",
          sm: "calc(33.33% - 6px)",
          md: "auto",
          lg: "auto",
          xl: "auto",
        },
        background: (theme) => theme.palette.background.paper,
        "& .MuiOutlinedInput-root": {
          "& fieldset": {
            borderColor: (theme) => theme.palette.divider,
          },
          "&:hover fieldset": {
            borderColor: (theme) => theme.palette.primary.main,
          },
        },
        "& .MuiInputLabel-root": {
          color: (theme) => theme.palette.text.secondary,
          fontSize: { xs: "11px", sm: "12px", md: "13px", lg: "14px", xl: "14px" },
        },
        "& .MuiSelect-select": {
          color: (theme) => theme.palette.text.primary,
          fontSize: { xs: "11px", sm: "12px", md: "13px", lg: "14px", xl: "14px" },
          padding: { xs: "6px 28px 6px 10px", sm: "7px 30px 7px 12px", md: "8px 32px 8px 12px", lg: "10px 32px 10px 14px", xl: "10px 32px 10px 14px" },
        },
        "& .MuiSelect-icon": {
          fontSize: { xs: "16px", sm: "18px", md: "20px", lg: "24px", xl: "24px" },
        },
      }}
      SelectProps={{
        MenuProps: {
          anchorOrigin: { vertical: "bottom", horizontal: "left" },
          transformOrigin: { vertical: "top", horizontal: "left" },
          PaperProps: {
            sx: { mt: 0.5 }, // push menu slightly below the select so it doesn't cover the field
          },
        },
      }}
    >
      <MenuItem value="All">All</MenuItem>
      <MenuItem value="APPROVED">APPROVED</MenuItem>
      <MenuItem value="PENDING">PENDING</MenuItem>
      <MenuItem value="REJECTED">REJECTED</MenuItem>
    </TextField>
  </Box>
);

export default FilterBar;
